// libraries
import { ReactElement } from 'react'
import _ from 'lodash'

// utils
import { useListConditions } from 'hooks'
import type { FormGalleryPassProps } from 'routers/pages/FormGallery'

// components
import { GalleryPageHeader } from 'components/common'
import useList from './useList'
import { PAGE_OPTIONS } from './constants'

const { customFiltersSpecs, pageName, entity, entityLabel, iconName } =
  PAGE_OPTIONS

const Forms = (tabsProps: FormGalleryPassProps): ReactElement => {
  const [listConditions, setListConditions] = useListConditions({
    defaultListConditions: PAGE_OPTIONS.listConditions,
    entity,
  })

  const { selectedView, tabs } = tabsProps

  const {
    list,
    listState,
    renderContent,
    toggleCreateEntityModal,
    columns,
    visibleColumns,
    setVisibleColumns,
  } = useList({
    listConditions,
    setListConditions,
    selectedView,
  })

  return (
    <>
      <GalleryPageHeader
        iconName={iconName}
        entity={entity}
        pageName={pageName}
        customFiltersSpecs={customFiltersSpecs}
        counts={list?.length}
        isLoading={listState.loading}
        actions={[
          {
            label: `New ${entityLabel}`,
            value: `create-new-&{entityLabel}`,
            onClick: () => toggleCreateEntityModal(true),
          },
        ]}
        toolboxOptions={PAGE_OPTIONS.toolboxOptions}
        conditions={listConditions}
        onConditionsChange={setListConditions}
        columns={columns}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
        {...(!_.isEmpty(tabs) && {
          tabsProps: _.pick(tabsProps, [
            'tabs',
            'tabsPosition',
            'onTabSelected',
            'selectedTab',
          ]),
        })}
      />
      <div className='galleryContainer'>{renderContent()}</div>
    </>
  )
}

export default Forms
